import React from 'react';
import { motion } from 'framer-motion';
export function CollaboratorsPage() {
  const collaborators = [{
    name: 'Prof. Peter Stephan',
    title: 'Professor',
    inst: 'TU Darmstadt'
  }, {
    name: 'Dr. Axel Sielaff',
    title: 'Researcher',
    inst: 'TU Darmstadt'
  }, {
    name: 'Prof. Martin Geier',
    title: 'Professor',
    inst: 'TU Braunschweig'
  }, {
    name: 'Prof. Yasuyuki Takata',
    title: 'Professor',
    inst: 'Kyushu University, Japan'
  }, {
    name: 'Prof. Daniel Orejon Mantecon',
    title: 'Professor',
    inst: 'University of Edinburgh'
  }, {
    name: 'Dr. Harish Sivasankaran',
    title: 'Researcher',
    inst: 'University of Tokyo'
  }, {
    name: 'Prof. Ramesh Narayanaswamy',
    title: 'Professor',
    inst: 'Curtin University'
  }, {
    name: 'Prof. Chandraveer Singh',
    title: 'Professor',
    inst: 'University of Toronto'
  }, {
    name: 'Prof. Marco Marengo',
    title: 'Professor',
    inst: 'University of Pavia'
  }];
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-301">
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-302">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-303">
          Research Collaborators
        </motion.h1>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-304">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-305">
          {collaborators.map((collab, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-200/50 rounded-xl p-8 text-center hover:bg-white hover:shadow-md transition-all border border-transparent hover:border-gray-200" data-id="element-306">
              <div className="w-24 h-24 mx-auto bg-gray-300 rounded-full mb-4 overflow-hidden border-4 border-white shadow-sm" data-id="element-307">
                <img src={`https://ui-avatars.com/api/?name=${collab.name.replace('Prof. ', '').replace('Dr. ', '')}&background=800000&color=fff`} alt={collab.name} className="w-full h-full object-cover" data-id="element-308" />
              </div>
              <h3 className="font-bold text-gray-900 font-serif text-lg border-b border-gray-300 pb-2 mb-2 inline-block" data-id="element-309">
                {collab.name}
              </h3>
              <p className="text-sm font-bold text-gray-700" data-id="element-310">{collab.title}</p>
              <p className="text-sm text-gray-600" data-id="element-311">{collab.inst}</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}